<script setup lang="ts">
const {
  text = undefined,
  disabled = false,
  fullWidth = false,
} = defineProps<{
  text?: string;
  disabled?: boolean;
  fullWidth?: boolean;
}>();

defineOptions({
  inheritAttrs: true,
});
</script>

<template>
  <button
    class="vtnz-theme pwt-theme pwt-button--base pwt-button--outlined"
    :class="{
      'pwt-rounded': fullWidth,
      'pwt-rounded-pill': !fullWidth,
      'pwt-full-width': fullWidth,
    }"
    v-bind="$attrs"
    :disabled="disabled"
  >
    <span class="pwt-text-truncate">
      <slot v-if="$slots.default"></slot>
      <template v-else>{{ text }}</template>
    </span>
  </button>
</template>

<style lang="css" scoped>
@import "./styles/pwt-theme.css";
@import "./styles/pwt-utilities.css";
@import "./styles/button-shared.css";

.pwt-button--outlined {
  padding: 10px 36px;
  min-width: 100px;
  background-color: transparent;
  border: 1px solid var(--primary, --palatinate-blue-100);
  color: var(--primary, --palatinate-blue-100);
  transition:
    background-color 150ms ease,
    border-color 150ms ease,
    color 150ms ease;
}

.pwt-button--outlined:hover {
  border-color: var(--primary80, --palatinate-blue-120);
  color: var(--primary80, --palatinate-blue-120);
}

.pwt-button--outlined:active {
  background-color: var(--primary20, --palatinate-blue-20);
  border-color: var(--primary90, --palatinate-blue-140);
  color: var(--primary90, --palatinate-blue-120);
}

.pwt-button--outlined:disabled {
  border-color: var(--gray20, --platinum);
  color: var(--gray400, --light-gray);
  cursor: default;
}

</style>
